<!--
 * @Author: shijianchen shijianchen@tujia.com
 * @Date: 2021-09-28 15:05:40
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @LastEditTime: 2022-11-15 20:48:51
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/linkmec/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="container">
    <!-- <Home :setHeight="()=>{setHeight(0)}" id="home"></Home> -->
    <div class="linkBanner">
      <img
        src="https://source.qunarzz.com/site/images/wns/20220812-shijianchen-link-1.jpg"
        alt=""
      />
      <div class="jump" @click="jump" v-maidian="'sight_home'"></div>
    </div>
    <div class="box2">
      <img
        src="https://source.qunarzz.com/site/images/wns/20220812-shijianchen-link-2.jpg"
        alt=""
      />
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div
            v-for="(item, index) in imgList"
            :key="index"
            class="swiper-slide slide1"
          >
            <img class="swiper" :src="item" alt="" />
          </div>
        </div>
      </div>
      <img
        class="box2_img"
        @click="jump"
        v-maidian="'sight'"
        src="https://source.qunarzz.com/site/images/wns/20220812-shijianchen-link-3.png"
        alt=""
      />
    </div>
    <div class="box2 box3">
      <img
        src="https://source.qunarzz.com/site/images/wns/20220812-shijianchen-link-4.jpg"
        alt=""
      />
      <div class="appoint">
        <div class="inputBox">
          <span class="name">姓名</span>
          <input
            v-model="name"
            class="input"
            type="text"
            placeholder="请输入您的姓名"
          />
        </div>
        <div class="inputBox">
          <span class="name">手机号</span>
          <input
            v-model="phone"
            class="input"
            type="text"
            placeholder="请输入您的手机号"
          />
        </div>
        <img
          @click="submit"
          class="submit"
          src="https://source.qunarzz.com/site/images/wns/20220812-shijianchen-link-submit.png"
          alt=""
        />
        <div class="inputBox checkFluid">
          <span class="checkbox active"></span>
          <div class="shouquan">
            我同意<i @click="policy" class="personal">《个人信息授权申明》</i>
          </div>
        </div>
      </div>
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div
            v-for="(item, index) in imgList2"
            :key="index"
            class="swiper-slide slide1"
          >
            <a :href="urlList[index]"
              ><img class="swiper swiper2" :src="item" alt=""
            /></a>
          </div>
        </div>
      </div>
    </div>
    <img
      src="https://source.qunarzz.com/site/images/wns/20220812-shijianchen-link-7.jpg"
      alt=""
    />
    <img
      src="https://source.qunarzz.com/site/images/wns/20220812-shijianchen-link-6.jpg"
      alt=""
    />
    <div v-maidian="'dialog'" @click="showDialog" class="dialog"></div>
  </div>
</template>
<script>
// import Home from './home.vue'
import showDialog from './dialog/gift';
import policyDialog from './dialog/policy/index';
import submitDialog from './dialog/gift2/index';
export default {
  data() {
    return {
      imgList: [
        'https://source.qunarzz.com/site/images/wns/20220525-shijianchen-e1.png',
        'https://source.qunarzz.com/site/images/wns/20220525-shijianchen-e2.png',
        'https://source.qunarzz.com/site/images/wns/20220525-shijianchen-e3.png',
        'https://source.qunarzz.com/site/images/wns/20220525-shijianchen-e4.png',
      ],
      imgList2: [
        'https://source.qunarzz.com/site/images/wns/20220629-shijianchen-l1.png',
        'https://source.qunarzz.com/site/images/wns/20220629-shijianchen-l2.png',
        'https://source.qunarzz.com/site/images/wns/20220629-shijianchen-l3.png',
      ],
      name: '',
      phone: '',
      urlList: [
        'https://d.qunar.com/Kwh4ij',
        'https://touch.travel.qunar.com/h5/topic/comment/29723605?showType=share&bd_source=app_personal_entrance',
        'https://touch.travel.qunar.com/h5/topic/comment/29669712?showType=share&bd_source=b_order_user',
      ],
    };
  },
  methods: {
    showDialog() {
      showDialog({});
    },
    policy() {
      policyDialog({});
    },
    jump() {
      if (hysdk.sniff.scheme) {
        location.href = hysdk.sniff.scheme + `://sight/detail?id=3839021180`;
      } else {
        location.href =
          'http://touch.piao.qunar.com/touch/detail.htm?id=3839021180';
      }
    },
    submit() {
      var reg = /^1[3456789]\d{9}$/gi;
      if (!this.name) {
        this.$dialog.alert({
          message: '请输入姓名',
        });
        return;
      } else if (this.phone == '') {
        this.$dialog.alert({
          message: '请输入手机号',
        });
      } else if (!reg.test(this.phone)) {
        this.$dialog.alert({
          message: '请输入正确的手机号',
        });
      }
      this.$axios
        .post('/keepInfo/keepInfoLinKe', {
          name: this.name,
          phone: this.phone,
        })
        .then((res) => {
          if (res.code == 200) {
            submitDialog({});
          } else {
            this.$dialog.alert({
              message: res.message,
            });
          }
        });
    },
  },
  mounted() {
    new Swiper('.swiper-container', {
      autoplay: {
        delay: 3000, //1秒切换一次
      },
      loop: true, // 循环模式选项
    });
  },
};
</script>
<style lang='less' scoped='true'>
img {
  display: block;
}
#container {
  background: #1a1c31;
  position: relative;
}
.linkBanner {
  position: relative;
  .linkJump {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100px;
  }
}
.swiper-container {
  height: 300px;
  z-index: 10;
  top: 124px;
}
input,
select {
  border: none;
  outline: none;
  background-color: transparent;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
}
.jump{
  position: absolute;
  left:0;
  bottom: 0%;
  width:100%;
  height:80px;
}
.box2 {
  position: relative;
  height: 480px;
  > img {
    position: absolute;
    left: 0;
    top: 0;
  }
  .box2_img {
    position: absolute;
    left: 50%;
    margin-left: -120px;
    bottom: 0;
    top: inherit;
    width: 240px;
  }
}
.box3 {
  position: relative;
  height: 689px;
  .swiper-container {
    top: 0;
  }
}
.dialog {
  position: absolute;
  left: 0;
  bottom: 188px;
  height: 300px;
  width: 100%;
}
.swiper2 {
  width: calc(100% - 40px);
  margin-left: auto;
  margin-right: auto;
}
.appoint {
  height: 255px;
  color: #959392;
  width: calc(100% - 60px);
  margin: 0 auto;
  padding-top: 140px;
}
.inputBox {
  transform: rotate(-8deg);
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  span {
    // transform: rotate(10deg);
    transform: skewX(-8deg);
    display: inline-block;
    width: 48px;
  }
  .input {
    width: 233px;
    margin-left: 5px;
    height: 32px;
    border: 1px solid #c5c5c5;
    transform: skewX(-8deg);
    color: #959392;
    text-align: center;
  }
}
.personal {
  font-style: normal;
  color: #ffe840;
  text-decoration: underline;
}
.checkbox {
  display: flex !important;
  width: 11px !important;
  height: 11px !important;
  border: 1px solid #ffffff;
  transform: skewX(-8deg);
  margin-right: 5px;
  align-items: center;
  justify-content: center;
  &.active {
    &:before {
      content: '';
      display: block;
      background: #ffe840;
      width: 6px;
      height: 6px;
    }
  }
}
.checkFluid {
  width: 200px;
  margin: 0 auto;
  position: relative;
  top: -3px;
}
.submit {
  position: relative;
  z-index: 2;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
}
</style>